import { useEffect, useState } from "react";
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import EmptyData from "../../../components/emptyData";
import ModalLoading from "../../../components/modalLoading";
import ProgressBar from "../../../components/progressBar";
import TableStorage from "../components/tableStorage";
import ManageLayout from "../../../layouts/manage";
import ToastTopHelper from "../../../utils/toast";
import FormStorage from "../components/formStorage";
import { clearData, exportProject, getProjects } from "../redux/action";
import {headers} from "../../../utils/callApi";
import './index.css';


function ManagerStorage() {
  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [project, setProject] = useState(null);

  const [showProgressBar, setShowProgressBar] = useState(false);

  const dispatch = useDispatch();
  const [
    page,
    totalPage,
    totalProjects,
    isGettingProjects,
    projects,
    isAddingProject,
    isEditingProject,
    isDeletingProject,
    exportPercent,
    exportData,
    isExportedFail
  ] = useSelector((state) => [
    state.manageStorage.page,
    state.manageStorage.totalPage,
    state.manageStorage.totalProjects,
    state.manageStorage.isGettingProjects,
    state.manageStorage.projects,
    state.manageStorage.isAddingProject,
    state.manageStorage.isEditingProject,
    state.manageStorage.isDeletingProject,
    state.manageStorage.exportPercent,
    state.manageStorage.exportData,
    state.manageStorage.isExportedFail
  ]);

  function getSheetData(data, header, headerRaw) {
    const sheetData = data.map(function (row) {
      return headerRaw.map(function (fieldName) {
        switch (fieldName) {
          case 'email_dep_head': {
            return row.dep_head ? row.dep_head.email :'';
          }
          case 'name_dep_head': {
            return row.dep_head ? row.dep_head.name : '';
          }
          case 'phone_dep_head': {
            return row.dep_head ? row.dep_head.phone : '';
          }
          case 'email_manager': {
            return row.manager ? row.manager.email : '';
          }
          case 'name_manager': {
            return row.manager ? row.manager.name : '';
          }
          case 'phone_manager': {
            return row.manager ? row.manager.phone : '';
          }
          default :{
            return (row[fieldName] || row[fieldName] === 0) ? row[fieldName] : "";
          }
        }
      });
    });
    
    return [[...header], ...sheetData];
  }

  function saveAsExcel() {
    const header = [
      'Tên dự án',
      'Dung lượng cấp (GB)',
      'Max file size (MB)',
      'Mô tả dự án',
      'Thời gian lưu trữ',
      'Domain',
      'API Key',
      'Email trưởng bộ phận',
      'Tên trưởng bộ phận',
      'SDT trưởng bộ phận',
      'Email người phụ trách',
      'Tên người phụ trách',
      'SDT người phụ trách',
      'Bộ phận',
      'Ngày cập nhật',
    ];
    
    const headerRaw = [
      'account_name',
      'capacity',
      'max_file_size',
      'description',
      'file_time',
      'domain',
      'api_key',
      'email_dep_head',
      'name_dep_head',
      'phone_dep_head',
      'email_manager',
      'name_manager',
      'phone_manager',
      'department',
      'update_date',
    ]
    const sheetData = getSheetData(exportData, header, headerRaw);
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    const wb = XLSX.utils.book_new();      
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1")
    XLSX.writeFile(wb, "ReportStorage.xlsx");
  }

  const breadCrumbs_storage= [
      {name: 'Phân vùng dự án'}
  ];

  useEffect(() => {
    if(isExportedFail) {
      ToastTopHelper.error("Xuất report thất bại.");
    }
  },[isExportedFail])

  useEffect(() => {
    if(exportPercent !== null && exportPercent !== 0) {
      if(exportPercent !== 100){
        dispatch(exportProject({page: (exportPercent * totalPage / 100) + 1}));
      } else {
        setShowProgressBar(true);
        saveAsExcel();
        setTimeout(() => {
          setShowProgressBar(false);
        },[500])
        ToastTopHelper.success("Xuất report thành công.");
      }
    }
  },[exportPercent])

  useEffect(() => {
    dispatch(getProjects({page: 1}));
  },[headers])

  useEffect(() => {
    return () => {
      dispatch(clearData())
    }
  },[])

  return (
    <>
      <ManageLayout activeIndex={3} breadcrumbs={breadCrumbs_storage}>
        <div className="main_user">
          <div className="el_user_1">
          </div>
          <div className="el_user_2">
            <div className="btn_el_user">
              <div className="btn_el_user_1"><Button onClick={async () => {
                if(totalPage !== 0){
                  dispatch(exportProject({page: 1}));
                }
              }}>Xuất Report</Button></div>
              <div className="btn_el_user_2"><Button onClick={() => {
                setIsEdit(false);
                setShow(true);
              }}>Thêm mới</Button></div>
            </div>
          </div>
          <div className="el_user_3">
          </div>
        </div>
        {exportPercent !== null &&
        <>
          {exportPercent !== 100  && <ProgressBar value_percent={exportPercent.toFixed(2)}></ProgressBar> }
          {exportPercent === 100  && showProgressBar && <ProgressBar value_percent={exportPercent.toFixed(2)}></ProgressBar> }
        </>
        }
        <div className="main_content">
          {projects.length === 0 && page === 0 && totalPage === 0 ? 
            <EmptyData title="Đang lấy dữ liệu."></EmptyData>
            :
            <>
            {totalProjects === 0 ? 
              <EmptyData title="Không có dữ liệu"></EmptyData>
              :
              <TableStorage 
                editProject={(project) => {
                  setIsEdit(true);
                  setShow(true);
                  setProject(project);
                }}
              ></TableStorage>
            }
            </>
          }
        </div>
      </ManageLayout>
      <FormStorage 
        show={show} 
        onHide={() => setShow(false)}
        isEdit={isEdit}
        project={{
          ...project,
        }}
      >
      </FormStorage>

      <ModalLoading 
        show={isAddingProject || isEditingProject || isDeletingProject}
        content={'Đang xử lý...'}
      ></ModalLoading>

      <ModalLoading 
        show={isGettingProjects}
        content={'Đang lấy dữ liệu...'}
      ></ModalLoading>

    </>
  )
}

export default ManagerStorage;